<template>
  <div class="dashboard">
    <h2>数据看板</h2>

    <!-- 邀请链接白色块 -->
    <div class="invite-section">
      <div class="invite-card">
        <h3>邀请好友</h3>
        <div class="invite-link-container">
          <div class="invite-link">
            <span class="link-text">{{ inviteLink }}</span>
          </div>
          <el-button type="primary" @click="copyInviteLink" :loading="copyLoading" class="copy-btn">
            {{ copyLoading ? '复制中...' : '复制链接' }}
          </el-button>
        </div>
        <div class="tips">
          <p>💡 Tip 1: 邀请好友注册可获得额外奖励</p>
          <p>💡 Tip 2: 好友成功注册后双方都能获得积分</p>
          <p>💡 Tip 3: 邀请越多，奖励越丰厚</p>
        </div>
      </div>
    </div>

    <div class="stats-grid">
      <div class="stat-card">
        <h3>分成比例</h3>
        <p class="value">{{ (userinfo.rate * 100) || 0 }}%</p>
      </div>
      <div class="stat-card">
        <h3>今日总收益</h3>
        <p class="value">¥{{ dashboardData.sumIncome || 0 }}</p>
      </div>
      <div class="stat-card">
        <h3>今日单集收益</h3>
        <p class="value">¥{{ dashboardData.todayIncome || 0 }}</p>
      </div>
      <div class="stat-card">
        <h3>今日积分收益</h3>
        <p class="value">¥{{ dashboardData.todayPointIncome || 0 }}</p>
      </div>
    </div>
    
    <div class="stats-grid">
      <div class="stat-card clickable" @click="showSubordinateList">
        <h3>下级总数</h3>
        <p class="value">{{ dashboardData.totalPid || 0 }}</p>
      </div>
      <div class="stat-card">
        <h3>今日下级分成总收益</h3>
        <p class="value">¥{{ dashboardData.commissionTotalIncome || 0 }}</p>
      </div>
      <div class="stat-card">
        <h3>今日下级分成现金收益</h3>
        <p class="value">¥{{ dashboardData.commissionMoneyIncome || 0 }}</p>
      </div>
      <div class="stat-card">
        <h3>今日下级分成积分收益</h3>
        <p class="value">¥{{ dashboardData.commissionPointIncome || 0 }}</p>
      </div>
    </div>
    <div class="charts-grid">
      <div class="chart-container">
        <h3>每日收入金额</h3>
        <div class="chart-wrapper">
          <div ref="moneyChartRef" class="chart" style="height: 300px;"></div>
        </div>
      </div>

      <div class="chart-container">
        <h3>每日收入积分</h3>
        <div class="chart-wrapper">
          <div ref="pointsChartRef" class="chart" style="height: 300px;"></div>
        </div>
      </div>
    </div>

    <!-- 下级列表弹窗 -->
    <el-dialog
      v-model="subordinateDialogVisible"
      title="下级列表"
      width="80%"
      :close-on-click-modal="false"
    >
      <div class="subordinate-list">
        <el-table
          :data="subordinateList"
          v-loading="subordinateLoading"
          border
          style="width: 100%"
        >
          <el-table-column label="下级头像" align="center">
            <template #default="{ row }">
              <el-avatar :size="40" :src="row.avatar" />
            </template>
          </el-table-column>
          <el-table-column prop="nickname" label="下级昵称" align="center"/>
          <el-table-column prop="username" label="联系号码" align="center" />
          <el-table-column prop="moeny" label="现金总抽佣" width="120"align="center">
            <template #default="{ row }">
              ¥{{ row.moeny || 0 }}
            </template>
          </el-table-column>
          <el-table-column prop="points" label="积分总抽佣" width="120" align="center">
            <template #default="{ row }">
              {{ row.points || 0 }}
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination-container" style="margin-top: 20px; text-align: right;">
          <el-pagination
            v-model:current-page="subordinatePagination.currentPage"
            v-model:page-size="subordinatePagination.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :total="subordinatePagination.total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSubordinateSizeChange"
            @current-change="handleSubordinateCurrentChange"
          />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'DashboardView',
  data() {
    return {
      copyLoading: false,
      userId: '',
      dashboardData: {
        worksCount: 0,
        todayIncome: 0,
        todayPointIncome: 0,
        sumIncome: 0
      },
      moneyChartData: [],
      pointsChartData: [],
      moneyChartInstance: null,
      pointsChartInstance: null,
      // 下级列表相关数据
      subordinateDialogVisible: false,
      subordinateList: [],
      subordinatePagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      subordinateLoading: false
    }
  },
  computed: {
    inviteLink() {
      const baseUrl = window.location.origin;
      return `${baseUrl}/register?invite=${this.userId}`;
    },
    // 获取用户信息中的分成比例
    userinfo() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
      return userInfo
    }
  },
  methods: {
    async copyInviteLink() {
      this.copyLoading = true;
      try {
        await navigator.clipboard.writeText(this.inviteLink);
        this.$message.success('邀请链接已复制到剪贴板');
      } catch (err) {
        // 降级方案：使用 document.execCommand
        const textArea = document.createElement('textarea');
        textArea.value = this.inviteLink;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        this.$message.success('邀请链接已复制到剪贴板');
      } finally {
        this.copyLoading = false;
      }
    },

    // 获取仪表板数据
    async fetchDashboardData() {
      try {
        const response = await this.$axios.get('/api/user/dashboard');
        console.log('Dashboard data response:', response);
        if (response.code === 1) {
          // 根据实际API返回格式映射数据
          const data = response.data;
          this.dashboardData = {
            worksCount: data.total_pid || 0,
            todayIncome: data.self_income?.money_income || 0,
            todayPointIncome: data.self_income?.point_income || 0,
            sumIncome: data.self_income?.total_income || 0,
            // 下级收益数据
            totalPid: data.total_pid || 0,
            commissionMoneyIncome: data.commission_income?.money_income || 0,
            commissionPointIncome: data.commission_income?.point_income || 0,
            commissionTotalIncome: data.commission_income?.total_income || 0
          };
        } else {
          this.$message.error(response.msg || '获取数据失败');
        }
      } catch (error) {
        console.error('获取仪表板数据失败:', error);
        this.$message.error('获取数据失败');
      }
    },

    // 获取每日收入数据
    async fetchDailyIncomeData() {
      try {
        const response = await this.$axios.get('/api/user/daymoney');
        if (response.code === 1) {
          this.moneyChartData = response.data.money_data || [];
          this.pointsChartData = response.data.points_data || [];

          // 测试数据：模拟某一天有8384收入的情况
          // 在实际使用中，请注释掉以下测试代码
          // if (this.moneyChartData.length > 0 && this.moneyChartData.every(item => item.amount === 0)) {
          //   // 如果所有数据都是0，添加一个测试数据点
          //   const testData = [...this.moneyChartData];
          //   if (testData.length > 5) {
          //     testData[5].amount = 8384; // 将第6天的数据改为8384
          //   }
          //   this.moneyChartData = testData;
          // }

          this.initMoneyChart();
          this.initPointsChart();
        } else {
          this.$message.error(response.msg || '获取图表数据失败');
        }
      } catch (error) {
        console.error('获取每日收入数据失败:', error);
        this.$message.error('获取图表数据失败');
      }
    },

    // 初始化金额图表
    initMoneyChart() {
      if (!this.$refs.moneyChartRef) return;

      // 销毁之前的图表实例
      if (this.moneyChartInstance) {
        this.moneyChartInstance.dispose();
      }

      // 创建新的图表实例
      this.moneyChartInstance = echarts.init(this.$refs.moneyChartRef);

      // 处理图表数据
      const dates = this.moneyChartData.map(item => item.date || '');
      const amounts = this.moneyChartData.map(item => item.amount || 0);

      // 配置图表选项
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            return `${params.name}<br/>收入: ¥${params.value}`;
          },
          backgroundColor: 'rgba(50, 50, 50, 0.7)',
          borderColor: '#333',
          textStyle: {
            color: '#fff'
          },
          alwaysShowContent: true
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: dates,
          axisLabel: {
            rotate: 45
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '¥{value}'
          }
        },
        series: [
          {
            name: '每日收入金额',
            type: 'line',
            data: amounts,
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            itemStyle: {
              color: '#ff85a2'
            },
            lineStyle: {
              color: '#ff85a2',
              width: 2
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(255, 133, 162, 0.3)' },
                { offset: 1, color: 'rgba(255, 133, 162, 0.1)' }
              ])
            },
            emphasis: {
              focus: 'series',
              itemStyle: {
                borderColor: '#fff',
                borderWidth: 2,
                shadowBlur: 10,
                shadowColor: 'rgba(255, 133, 162, 0.5)'
              }
            }
          }
        ]
      };

      // 设置图表选项
      this.moneyChartInstance.setOption(option);
    },

    // 初始化积分图表
    initPointsChart() {
      if (!this.$refs.pointsChartRef) return;

      // 销毁之前的图表实例
      if (this.pointsChartInstance) {
        this.pointsChartInstance.dispose();
      }

      // 创建新的图表实例
      this.pointsChartInstance = echarts.init(this.$refs.pointsChartRef);

      // 处理图表数据
      const dates = this.pointsChartData.map(item => item.date || '');
      const amounts = this.pointsChartData.map(item => item.amount || 0);

      // 配置图表选项
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            return `${params.name}<br/>积分: ${params.value}`;
          },
          backgroundColor: 'rgba(50, 50, 50, 0.7)',
          borderColor: '#333',
          textStyle: {
            color: '#fff'
          },
          alwaysShowContent: true
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: dates,
          axisLabel: {
            rotate: 45
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          }
        },
        series: [
          {
            name: '每日收入积分',
            type: 'line',
            data: amounts,
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            itemStyle: {
              color: '#67C23A'
            },
            lineStyle: {
              color: '#67C23A',
              width: 2
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(103, 194, 58, 0.3)' },
                { offset: 1, color: 'rgba(103, 194, 58, 0.1)' }
              ])
            },
            emphasis: {
              focus: 'series',
              itemStyle: {
                borderColor: '#fff',
                borderWidth: 2,
                shadowBlur: 10,
                shadowColor: 'rgba(103, 194, 58, 0.5)'
              }
            }
          }
        ]
      };

      // 设置图表选项
      this.pointsChartInstance.setOption(option);
    },

    // 处理窗口大小变化
    handleResize() {
      if (this.moneyChartInstance) {
        this.moneyChartInstance.resize();
      }
      if (this.pointsChartInstance) {
        this.pointsChartInstance.resize();
      }
    },

    // 显示下级列表弹窗
    showSubordinateList() {
      this.subordinateDialogVisible = true;
      this.fetchSubordinateList();
    },

    // 获取下级列表
    async fetchSubordinateList() {
      this.subordinateLoading = true;
      try {
        const params = {
          page: this.subordinatePagination.currentPage,
          pageSize: this.subordinatePagination.pageSize
        };

        const response = await this.$axios.get('/api/bloger/pid', { params });
        console.log('下级列表响应:', response);
        
        if (response.code === 1) {
          // 根据实际API返回格式映射数据
          this.subordinateList = response.data || [];
          // 更新分页信息
          if (response.meta) {
            this.subordinatePagination.total = response.meta.total_count || 0;
            this.subordinatePagination.currentPage = response.meta.current_page || 1;
            this.subordinatePagination.pageSize = response.meta.page_size || 10;
          }
        } else {
          this.$message.error(response.msg || '获取下级列表失败');
        }
      } catch (error) {
        console.error('获取下级列表失败:', error);
        this.$message.error('获取下级列表失败');
      } finally {
        this.subordinateLoading = false;
      }
    },

    // 下级列表分页大小改变
    handleSubordinateSizeChange(size) {
      this.subordinatePagination.pageSize = size;
      this.subordinatePagination.currentPage = 1;
      this.fetchSubordinateList();
    },

    // 下级列表页码改变
    handleSubordinateCurrentChange(page) {
      this.subordinatePagination.currentPage = page;
      this.fetchSubordinateList();
    }
  },
  async mounted() {
    // 从缓存中获取用户信息
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    if (userInfo && userInfo.id) {
      this.userId = userInfo.id.toString();
    } else {
      // 如果缓存中没有用户信息，尝试从 store 获取
      const storeUserInfo = this.$store?.getters?.userInfo;
      if (storeUserInfo && storeUserInfo.id) {
        this.userId = storeUserInfo.id.toString();
      } else {
        console.warn('无法获取用户ID，邀请链接可能无法正常工作');
      }
    }

    // 获取数据
    await this.fetchDashboardData();
    await this.fetchDailyIncomeData();
  },

  beforeUnmount() {
    // 清理图表实例和事件监听器
    if (this.moneyChartInstance) {
      this.moneyChartInstance.dispose();
      this.moneyChartInstance = null;
    }
    if (this.pointsChartInstance) {
      this.pointsChartInstance.dispose();
      this.pointsChartInstance = null;
    }
    window.removeEventListener('resize', this.handleResize);
  }
}
</script>

<style scoped>
.dashboard {
  padding: 20px;
}

.invite-section {
  margin-bottom: 20px;
}

.invite-card {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.invite-card h3 {
  margin-top: 0;
  color: #333;
  font-size: 18px;
  margin-bottom: 15px;
}

.invite-link-container {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 15px;
}

.invite-link {
  flex: 1;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 10px 15px;
  overflow: hidden;
}

.link-text {
  font-size: 14px;
  color: #495057;
  word-break: break-all;
}

.copy-btn {
  white-space: nowrap;
  min-width: 100px;
}

.tips {
  border-top: 1px solid #e9ecef;
  padding-top: 15px;
}

.tips p {
  margin: 5px 0;
  font-size: 14px;
  color: #6c757d;
}

.tips p:first-child {
  margin-top: 0;
}

.tips p:last-child {
  margin-bottom: 0;
}

.stats-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin: 20px 0;
}

.stat-card {
  flex: 1;
  min-width: 200px;
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.stat-card.clickable {
  cursor: pointer;
  transition: all 0.3s ease;
}

.stat-card.clickable:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 1px solid #409EFF;
}

.stat-card h3 {
  margin-top: 0;
  color: #666;
  font-size: 16px;
}

.stat-card .value {
  font-size: 24px;
  font-weight: bold;
  margin: 10px 0 0;
}

.stat-card .value.clickable {
  cursor: pointer;
  transition: all 0.3s ease;
  color: #409EFF;
}

.stat-card .value.clickable:hover {
  color: #67C23A;
  transform: scale(1.05);
  text-decoration: underline;
}

.charts-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-top: 20px;
}

.chart-container {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.chart-wrapper {
  margin-top: 15px;
}

.chart {
  width: 100%;
  background: #f5f5f5;
  border-radius: 4px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .charts-grid {
    grid-template-columns: 1fr;
  }
}
</style>
